import { type LucideIcon } from 'lucide-react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

type Props = {
  icon: LucideIcon;
  title: React.ReactNode;
  description?: React.ReactNode;
  note?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
};

// The shared shell of the escrow summary cards: icon title, optional header extras, then the card's own content
const SummaryCard = ({
  icon: Icon,
  title,
  description,
  note,
  action,
  className,
  children,
}: React.PropsWithChildren<Props>) => {
  return (
    <Card className={className}>
      <CardHeader className="relative pb-3.5">
        <div className="flex items-center justify-between gap-2">
          <CardTitle className="flex items-center gap-2">
            <Icon className="size-4" />
            {title}
          </CardTitle>
          {note && <span className="text-xs text-muted-foreground">{note}</span>}
          {action}
        </div>
        {description && <CardDescription className="text-xs">{description}</CardDescription>}
      </CardHeader>
      <CardContent className="stack-table-cells">{children}</CardContent>
    </Card>
  );
};

export default SummaryCard;
